import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
  MatNoDataRow,
} from '@angular/material/table';
import { UsersService } from '@core/services/users.service';
import { User } from '@shared/models';
import { first } from 'rxjs';
import { CompagnieLinkFormComponent } from 'src/app/modules/dashboard/components/compagnie-link-form/compagnie-link-form.component';
import { RegisterAdminFormComponent } from 'src/app/modules/dashboard/components/register-admin-form/register-admin-form.component';
import { MatIcon } from '@angular/material/icon';
import { HasRoleDirective } from '../../directives/has-role.directive';
import { MatIconButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';

@Component({
  selector: 'app-table-users',
  templateUrl: './table-users.component.html',
  styleUrls: ['./table-users.component.scss'],
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    HasRoleDirective,
    MatIconButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatNoDataRow,
  ],
})
export class TableUsersComponent implements OnInit, OnChanges {
  private readonly userService = inject(UsersService);

  @Output() shouldRefresh: EventEmitter<void> = new EventEmitter();

  @Input({ required: true }) users: User[];

  @Input() userMenuContainer: string[];

  private readonly dialog = inject(MatDialog);

  protected dataSource: MatTableDataSource<User>;

  protected displayedColumns: string[] = [
    'id',
    'role',
    'lastName',
    'email',
    'compagnie',
    'settings',
  ];

  ngOnInit(): void {
    this.userMenuContainer = this.userMenuContainer || ['delete'];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.users) {
      this.dataSource = new MatTableDataSource<User>(this.users);
    }
  }

  openUpdate(user: User): void {
    const dialogRef = this.dialog.open(RegisterAdminFormComponent, {
      data: user,
    });
    dialogRef
      .afterClosed()
      .pipe(first())
      .subscribe(() => {
        this.shouldRefresh.emit();
      });
  }

  openCompagnieLink(user: User): void {
    const dialogRef = this.dialog.open(CompagnieLinkFormComponent, {
      data: user,
    });
    dialogRef
      .afterClosed()
      .pipe(first())
      .subscribe(() => {
        this.shouldRefresh.emit();
      });
  }

  delete(user: User): void {
    this.userService.delete(user.id).subscribe(() => {
      this.shouldRefresh.emit();
    });
  }
}
